module.exports = __webpack_public_path__ + "img/pan.0f2c4887.svg";